import globalStrings from './global';
import routeStrings from './routes';
import notificationStrings from './notifications';
import titleStrings from './titles';
import quizStrings from './quiz';
import howToStrings from './howTo';
import prizeStrings from './prizes';
import bannerStrings from './banners';
import buttonStrings from './buttons';
import heatstreakStrings from './heatstreak';
import dateStrings from './dates';
import historyStrings from './history';
import leaderboardStrings from './leaderboard';
import challengeStrings from './challenges';
import onboardingStrings from './onboarding';
import rolesStrings from './roles';
import getNewAppStrings from './getNewApp';

const strings = {
  ...globalStrings,
  ...routeStrings,
  ...notificationStrings,
  ...titleStrings,
  ...quizStrings,
  ...howToStrings,
  ...prizeStrings,
  ...bannerStrings,
  ...buttonStrings,
  ...heatstreakStrings,
  ...historyStrings,
  ...dateStrings,
  ...leaderboardStrings,
  ...challengeStrings,
  ...onboardingStrings,
  ...rolesStrings,
  ...getNewAppStrings,
};

export default strings;
